import React from "react";
import { useHubspotForm } from "@aaronhayes/react-use-hubspot-form";

const HubspotForm = ({ portalId, formId, id }) => {
  const { loaded, error, formCreated } = useHubspotForm({
    portalId,
    formId,
    target: `#${id}`,
  });

  if (error) {
    console.error("Error loading HubSpot form:", error);
    return <div>Error loading form</div>;
  }

  if (!loaded) {
    return <div>Loading form...</div>;
  }

  return <div id={id} />;
};

export default HubspotForm;
